import { render, staticRenderFns } from "./modalPedidos.vue?vue&type=template&id=c6969650&scoped=true"
import script from "./modalPedidos.vue?vue&type=script&lang=js"
export * from "./modalPedidos.vue?vue&type=script&lang=js"
import style0 from "./modalPedidos.vue?vue&type=style&index=0&id=c6969650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6969650",
  null
  
)

export default component.exports